<template>
  <helper-input-btn>
    <erp-input
        ref="input"
        @input="__set"
        slot="input"
        simple-border
        v-model="description"
        @keydown.enter.prevent.stop="search"
        readonly
    >
      <u-popover v-if="this.findedData" hover :hover-delay="500" class="popover-user-profile" anchor="bottom middle"
                 self="top middle" :offset="[10, 10]">
        <div class="wrapper bg-white font-12">
          <div class="row">
            <div class="col m-r">ID do bem: <strong>{{findedData.id}}</strong></div>
          </div>
          <div class="row m-t">
            <div class="col m-r">Nome: <strong>{{findedData.pessoa.name}}</strong></div>
          </div>
          <div class="m-t">
            <e-btn label="Acessar reboquista" />
          </div>
        </div>
      </u-popover>
    </erp-input>
    <a @click="search"><i class="erp-icon search min"></i> </a>
    <u-icon v-if="allowNew" name="plus-circle" type="fa" icon-style="light" class="m-l-xs cursor-pointer" />
  </helper-input-btn>
</template>

<script>
import InputMixin from '../../../../reuse/input/mixin'
import {HelperInputBtn} from 'uloc-vue-plugin-erp'
import {UPopover} from 'uloc-vue'
import search from '../../windows/search/SearchReboquista'

export default {
  name: 'ReboquistaInput',
  mixins: [InputMixin],
  props: {
    allowNew: {type: Boolean, default: true},
    solicitacao: {required: false}
  },
  data () {
    return {
      findedData: this.value,
      description: this.value ? `${this.value.id} - ${this.value.pessoa.name}` : null,
    }
  },
  watch: {
    value (val) {
      this.$nextTick(() => {
        this.$emit('reboquistaSelecionado', this.findedData)
      })
    }
  },
  components: {HelperInputBtn, UPopover},
  methods: {
    search: search
  }
}
</script>
